var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.93479901,30.0835613 L33.2442269,30.2219084 C34.3487841,30.2271222 35.2484313,29.3359282 35.253645,28.231371 C35.2553877,27.8621695 35.1548991,27.499691 34.9633101,27.1840861 L20.4436827,3.26588361 C19.870497,2.32167395 18.6404049,2.02089963 17.6961953,2.59408537 C17.4278016,2.75701464 17.201538,2.98084531 17.0357167,3.24746188 L2.24591622,27.0273172 C1.66255644,27.9652752 1.95001507,29.1985469 2.88797303,29.7819067 C3.20227901,29.9773882 3.5646663,30.0818142 3.93479901,30.0835613 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Conversation-Alert-",
    transform: "translate(-9.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Warning",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.733333, 2.733333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Semantic/Warning",
    mask: "url(#mask-2)",
    fill: "#F1C250"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.366667, -2.733333)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M19.4710554,21.0723325 L16.941951,21.0723325 L16.4677439,10.9333333 L19.9226812,10.9333333 L19.4710554,21.0723325 Z M18.2065032,26.2208667 C17.2129264,26.2208667 16.4,25.3853589 16.4,24.4143635 C16.4,23.4207867 17.2129264,22.585279 18.2065032,22.585279 C19.20008,22.585279 20.0355877,23.4207867 20.0355877,24.4143635 C20.0355877,25.3853589 19.20008,26.2208667 18.2065032,26.2208667 Z",
    id: "!",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e74648eb40b7e6da7787c38a64cc1f04.svg";
export { ForwardRef as ReactComponent };